import Hotjar from "@hotjar/browser";

import { isDevelopment } from "@/constants/isDevelopement";

const siteId = import.meta.env.VITE_HOTJAR_ID;
const hotjarVersion = import.meta.env.VITE_HOTJAR_VERSION;

if (!isDevelopment) {
  Hotjar.init(siteId, hotjarVersion);
}
